"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthContextProvider = exports.AuthContext = void 0;
var tslib_1 = require("tslib");
var ability_1 = require("@casl/ability");
var react_1 = tslib_1.__importDefault(require("react"));
var set_credentials_from_url_1 = require("../helpers/set-credentials-from-url");
// ----------------------------------------------------------------------
var Types;
(function (Types) {
    Types["INITIAL"] = "INITIAL";
    Types["LOGIN"] = "LOGIN";
    Types["REGISTER"] = "REGISTER";
    Types["LOGOUT"] = "LOGOUT";
})(Types || (Types = {}));
var initialState = {
    isAuthenticated: false,
    isInitialized: false,
    user: null,
    ability: new ability_1.Ability(),
    abilityUpdatedAt: Date.now(),
};
function reducer(state, action) {
    if (action.type === Types.INITIAL) {
        return tslib_1.__assign(tslib_1.__assign({}, state), { ability: state.ability.update(action.payload.rules || {}), abilityUpdatedAt: Date.now(), isInitialized: true, isAuthenticated: action.payload.isAuthenticated, user: action.payload.user });
    }
    if (action.type === Types.LOGIN) {
        return tslib_1.__assign(tslib_1.__assign({}, state), { isAuthenticated: true, user: action.payload.user });
    }
    if (action.type === Types.REGISTER) {
        return tslib_1.__assign(tslib_1.__assign({}, state), { isAuthenticated: true, user: action.payload.user });
    }
    if (action.type === Types.LOGOUT) {
        return tslib_1.__assign(tslib_1.__assign({}, state), { isAuthenticated: false, user: null });
    }
    return state;
}
exports.AuthContext = react_1.default.createContext(null);
var AuthContextProvider = function (_a) {
    var clientV1 = _a.clientV1, children = _a.children;
    var _b = react_1.default.useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var initialize = react_1.default.useCallback(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var credentials, _a, exchangeToken, refreshToken, accessToken, res, res, res, err_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!clientV1) {
                        throw new Error('`clientV1` prop must be provided to <AuthContextProvider />.');
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 15, 16, 18]);
                    credentials = clientV1.getCredentials();
                    return [4 /*yield*/, (0, set_credentials_from_url_1.setCredentialsFromUrl)(credentials)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, credentials.getTokens()];
                case 3:
                    _a = _b.sent(), exchangeToken = _a.exchangeToken, refreshToken = _a.refreshToken, accessToken = _a.accessToken;
                    if (!exchangeToken) return [3 /*break*/, 7];
                    return [4 /*yield*/, clientV1.post('/auth/exchange', { exchangeToken: exchangeToken })];
                case 4:
                    res = _b.sent();
                    if (!((res === null || res === void 0 ? void 0 : res.accessToken) && (res === null || res === void 0 ? void 0 : res.refreshToken) && res.accessToken !== '' && res.refreshToken !== '')) return [3 /*break*/, 6];
                    return [4 /*yield*/, credentials.setTokens(res.accessToken, res.refreshToken)];
                case 5:
                    _b.sent();
                    _b.label = 6;
                case 6:
                    dispatch({ type: Types.INITIAL, payload: { isAuthenticated: true, user: res.user, rules: res.rules } });
                    return [3 /*break*/, 14];
                case 7:
                    if (!refreshToken) return [3 /*break*/, 11];
                    return [4 /*yield*/, clientV1.post('/auth/update', { refreshToken: refreshToken })];
                case 8:
                    res = _b.sent();
                    if (!((res === null || res === void 0 ? void 0 : res.accessToken) && (res === null || res === void 0 ? void 0 : res.refreshToken) && res.accessToken !== '' && res.refreshToken !== '')) return [3 /*break*/, 10];
                    return [4 /*yield*/, credentials.setTokens(res.accessToken, res.refreshToken)];
                case 9:
                    _b.sent();
                    _b.label = 10;
                case 10:
                    dispatch({ type: Types.INITIAL, payload: { isAuthenticated: true, user: res.user, rules: res.rules } });
                    return [3 /*break*/, 14];
                case 11:
                    if (!accessToken) return [3 /*break*/, 13];
                    return [4 /*yield*/, clientV1.get('/auth/check')];
                case 12:
                    res = _b.sent();
                    dispatch({ type: Types.INITIAL, payload: { isAuthenticated: true, user: res.user, rules: res.rules } });
                    return [3 /*break*/, 14];
                case 13:
                    dispatch({ type: Types.INITIAL, payload: { isAuthenticated: false, user: null, rules: null } });
                    _b.label = 14;
                case 14: return [3 /*break*/, 18];
                case 15:
                    err_1 = _b.sent();
                    console.error(err_1);
                    dispatch({ type: Types.INITIAL, payload: { isAuthenticated: false, user: null, rules: null } });
                    return [3 /*break*/, 18];
                case 16: return [4 /*yield*/, clientV1.getCredentials().deleteExchangeToken()];
                case 17:
                    _b.sent();
                    return [7 /*endfinally*/];
                case 18: return [2 /*return*/];
            }
        });
    }); }, [clientV1]);
    react_1.default.useEffect(function () {
        initialize();
    }, [initialize]);
    var value = react_1.default.useMemo(function () { return ({
        isInitialized: state.isInitialized,
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        ability: state.ability,
        abilityUpdatedAt: state.abilityUpdatedAt,
    }); }, [state.isInitialized, state.isAuthenticated, state.user, state.abilityUpdatedAt]);
    return react_1.default.createElement(exports.AuthContext.Provider, { value: value }, children);
};
exports.AuthContextProvider = AuthContextProvider;
// ----------------------------------------------------------------------
